// Filter out React.createFactory deprecation warnings from third-party libraries
const orgError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('React.createFactory() is deprecated')) {
    return;
  }
  orgError(...args);
};

const orgWarn = console.warn;
console.warn = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('React.createFactory() is deprecated')) {
    return;
  }
  orgWarn(...args);
};

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global click handler to trigger native calendar picker popup on date input click
document.addEventListener('click', (event) => {
  const target = event.target;
  if (target && target.tagName === 'INPUT' && target.type === 'date') {
    if (typeof target.showPicker === 'function') {
      try {
        target.showPicker();
      } catch (e) {
        // Ignore if picker is already open or user gesture restrictions apply
      }
    }
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
